export const fundamentalMedicineConst = {
  path: "/single-programs/fundamental-medicine",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ФУНДАМЕНТАЛЬНАЯ МЕДИЦИНА",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> бакалавра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Фундаментальная медицина — основа будущих открытий</h2>
      <p>
        Фундаментальная медицина — это не клиническая практика, а наука, лежащая в её основе. Эта программа для тех, кто стремится глубоко
        понять, как работает человеческое тело на уровне клеток, генов и биохимических процессов. Именно здесь рождаются инновации, которые
        в будущем становятся лекарствами, методами диагностики и лечения.
      </p>
      <p>
        Мы готовим специалистов, способных работать в лабораториях, участвовать в международных исследованиях и вносить вклад в развитие
        медицины на молекулярном и клеточном уровне.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Анатомия и гистология</li>
        <li>Физиология и патофизиология человека</li>
        <li>Биохимия и молекулярная биология</li>
        <li>Генетика и геномика</li>
        <li>Клеточная биология и микробиология</li>
        <li>Иммунология и фармакология</li>
        <li>Методы научных исследований и лабораторная практика</li>
        <li>Биоинформатика и статистика</li>
        <li>Этические стандарты в биомедицинской науке</li>
      </ul>
      <p>
        Программа сочетает теорию с практикой — лабораторные занятия, участие в научных проектах, исследовательские стажировки в
        университетах и институтах Европы.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Медицинский или биомедицинский исследователь</li>
        <li>Лаборант в научно-исследовательских центрах и фармкомпаниях</li>
        <li>Специалист по генетическим или молекулярным анализам</li>
        <li>Преподаватель в университетах и колледжах</li>
        <li>Биотехнолог или аналитик в лабораториях контроля качества</li>
        <li>Аспирант и будущий кандидат наук</li>
      </ul>
      <h2>Востребованность и доход</h2>
      <p>
        Специалисты в области фундаментальной медицины востребованы как в научной сфере, так и в фармацевтической и биотехнологической
        индустрии.
      </p>
      <p>
        <strong>Средний уровень дохода в Европе — от €45,000 до €85,000 в год,</strong> с перспективой роста в академии и частном секторе.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, открывающий путь в международную науку</li>
        <li>Гибкий формат обучения: очно или дистанционно</li>
        <li>Современные лаборатории и виртуальные симуляции</li>
        <li>Возможность публикаций и участия в научных конференциях</li>
        <li>Обучение на русском или английском языке</li>
        <li>Индивидуальное сопровождение на всех этапах учёбы и карьеры</li>
      </ul>
      <h2>Учёба, которая делает вклад в науку</h2>
      <p>
        Наши студенты работают в командах с учеными, участвуют в международных проектах, стажируются в исследовательских институтах и уже на
        этапе бакалавриата делают первые шаги в науку.
      </p>
      <br />
      <p className="padding-left">
        «Фундаментальная медицина — это поиск истины. Мы обучаем тех, кто создаёт знания, а не просто ими пользуется.»
      </p>
      <h2>Как поступить?</h2>
      <p>
        Поступление начинается с простого шага: заполните форму заявки, прикрепите документы — и мы свяжемся с вами. Приёмная комиссия
        проконсультирует по всем этапам и поможет начать обучение в удобный для вас срок.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Фундаментальная медицина — основа будущих открытий
    Фундаментальная медицина — это не клиническая практика, а наука, лежащая в её основе. Эта программа для тех, кто стремится глубоко понять, как работает человеческое тело на уровне клеток, генов и биохимических процессов. Именно здесь рождаются инновации, которые в будущем становятся лекарствами, методами диагностики и лечения.
    Мы готовим специалистов, способных работать в лабораториях, участвовать в международных исследованиях и вносить вклад в развитие медицины на молекулярном и клеточном уровне.

    Что вы будете изучать?
    • Анатомия и гистология
    • Физиология и патофизиология человека
    • Биохимия и молекулярная биология
    • Генетика и геномика
    • Клеточная биология и микробиология
    • Иммунология и фармакология
    • Методы научных исследований и лабораторная практика
    • Биоинформатика и статистика
    • Этические стандарты в биомедицинской науке
    Программа сочетает теорию с практикой — лабораторные занятия, участие в научных проектах, исследовательские стажировки в университетах и институтах Европы.

    Кем можно работать после окончания?
    • Медицинский или биомедицинский исследователь
    • Лаборант в научно-исследовательских центрах и фармкомпаниях
    • Специалист по генетическим или молекулярным анализам
    • Преподаватель в университетах и колледжах
    • Биотехнолог или аналитик в лабораториях контроля качества
    • Аспирант и будущий кандидат наук

    Востребованность и доход
    Специалисты в области фундаментальной медицины востребованы как в научной сфере, так и в фармацевтической и биотехнологической индустрии.
    Средний уровень дохода в Европе — от €45,000 до €85,000 в год, с перспективой роста в академии и частном секторе.

    Почему выбирают нас?
    • Европейский диплом, открывающий путь в международную науку
    • Гибкий формат обучения: очно или дистанционно
    • Современные лаборатории и виртуальные симуляции
    • Возможность публикаций и участия в научных конференциях
    • Обучение на русском или английском языке
    • Индивидуальное сопровождение на всех этапах учёбы и карьеры

    Учёба, которая делает вклад в науку
    Наши студенты работают в командах с учеными, участвуют в международных проектах, стажируются в исследовательских институтах и уже на этапе бакалавриата делают первые шаги в науку.
    «Фундаментальная медицина — это поиск истины. Мы обучаем тех, кто создаёт знания, а не просто ими пользуется.»

    Как поступить?
    Поступление начинается с простого шага: заполните форму заявки, прикрепите документы — и мы свяжемся с вами. Приёмная комиссия проконсультирует по всем этапам и поможет начать обучение в удобный для вас срок.
  `,
};
